// extracted by mini-css-extract-plugin
export default {"container":"SettingsIndex_container__hsrf3"};